<script lang="ts">
  import { spaNavigate } from "@kontextwerk/control-web-frame/navigation"
  import type { CustomerImportReviewSummary } from "../../../../../../../../../../api/kehrblatt/imports"

  let {
    organizationPathSegment = null,
    summary = null,
  }: {
    organizationPathSegment?: string | null
    summary?: CustomerImportReviewSummary | null
  } = $props()

  const criticalCount = $derived(summary?.counts_by_severity?.critical ?? 0)
  const mediumOrLowCount = $derived(
    (summary?.counts_by_severity?.medium ?? 0) +
      (summary?.counts_by_severity?.low ?? 0) +
      (summary?.counts_by_severity?.info ?? 0),
  )

  const orgPath = $derived(
    organizationPathSegment
      ? `/organizations/${encodeURIComponent(organizationPathSegment)}`
      : null,
  )

  const goToDistrict = () => {
    if (orgPath) spaNavigate(`${orgPath}/customers?tab=1`, { noSearchParam: false })
  }

  const goToWorkOrders = () => {
    if (orgPath) spaNavigate(`${orgPath}/work-orders`, { noSearchParam: false })
  }

  const goToDataReview = () => {
    if (orgPath) spaNavigate(`${orgPath}/customers?tab=1`, { noSearchParam: false })
  }
</script>

{#if criticalCount > 0}
  <p class="warning">
    Es gibt {criticalCount} kritische Punkte. Prüfen Sie diese, bevor Sie automatische Kontaktaufnahme
    starten.
  </p>
{:else if mediumOrLowCount > 0}
  <p
    >Kehrblatt hat Ihre Daten übernommen. Offene Hinweise können Sie später in der Datenprüfung
    weiter ansehen.</p
  >
{:else}
  <p>Kehrblatt hat Ihre Daten übernommen und keine offenen Prüfpunkte erkannt.</p>
{/if}

<style lang="less">
  p {
    margin: 0;
    color: color-mix(in srgb, var(--text-100) 72%, transparent);
  }
  .warning {
    border: 1px solid #dc2626;
    border-radius: 0;
    padding: 0.8rem;
    background: #fff5f5;
    color: #7f1d1d !important;
    font-weight: 700;
  }
</style>
